import React, {Component, useState, useEffect} from "react";
import Footer from "../layouts/Footer";
import Navbar from "../layouts/Navbar";
import {WebLink, SiteWide} from "../customComponents";
import FullScreenInputHolder from "../customComponents/FullScreenInputHolder";

import NoData from "../customComponents/NoData";

import Section from "../layouts/Section";
import {useHistory, useLocation} from 'react-router-dom';

import Slider from "react-slick";
import {Images} from "../customComponents";
import Colors from '../../utility/Colors';
import Helper1, {notify, styles, money, decimalCount, moneyStatus} from '../../utility/Helper1';

import {depositActions, withdrawalActions} from '../../redux/actions';
import { useSelector, useDispatch } from 'react-redux';
import { allDepositSelect, userSelect, allRemoteSettingsSelect, homeScreenStatSelect } from '../../redux/selectors/index';

import LoadingOverlay from 'react-loading-overlay';
import {CopyToClipboard} from 'react-copy-to-clipboard';

import {mainStyle, mainColor, header, footer, otherColors} from '../../utility/styles';

import { AiOutlineWallet, AiFillCloseCircle, AiOutlineCopy, AiOutlineCloudUpload } from "react-icons/ai";
import CustomAgo from "../customComponents/CustomAgo";
import Countdown from 'react-countdown';
import { Eye, EyeOff, Copy, Wallet, Shield, TrendingDown, AlertCircle, CheckCircle, History } from 'lucide-react';

const amountSuggestion = [10, 20, 50, 100, 200, 500, 800, 1000];


function Withdrawal() {

    const userData = useSelector(userSelect);
    const site_settings = useSelector(allRemoteSettingsSelect);
    const [loadingText, setLoadingText]   = useState('Loading history...');

    const [loading, setloading]   = useState(false);

    const finance = useSelector(homeScreenStatSelect);
    const [currencySelected, setCurrencySelected]   = useState(finance?.[0]);

    const allDepositData = useSelector(allDepositSelect);

    const [amount, setAmount]   = useState('');
    const [googleAuth, setGoogleAuth]   = useState('');
    const [withdrawalPin, setWithdrawalPin]     = useState('');
    
    // New UI state variables
    const [showPin, setShowPin] = useState(false);
    const [errors, setErrors] = useState({});

    const dispatch = useDispatch();
   

    

    const getPendingPayment = allDepositData?.filter((item, index) => item.status < 2);

    // Helper functions for new UI
    const handleCurrencyChange = (currency) => {
        setCurrencySelected(currency);
        setAmount('');
        setErrors({});
    };

    const handleAmountSuggestion = (suggestedAmount) => {
        setAmount(suggestedAmount.toString());
    };

    const validateForm = () => {
        const newErrors = {};
        
        if (!amount || isNaN(amount) || parseFloat(amount) <= 0) {
            newErrors.amount = 'Please enter a valid amount';
        }

        if (!withdrawalPin) {
            newErrors.withdrawalPin = 'Withdrawal PIN is required';
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const processWithdrawal = (e) => {
        
        e.preventDefault();

        // Validate form using new validation
        if (!validateForm()) {
            return;
        }

        if((userData?.usdttrc20wallet?.length ?? 0) < '5'){ 
            notify('Please bind your wallet details before withdrawal.');
            return false;
        }

        if((isNaN(amount)) || (amount == 0)){
            // notify('Enter amount', 0);
            return false;
        }


        if(withdrawalPin == ''){
            notify('Please enter your withdrawal pin', 0);
            return false;
        }


        setloading(true);
        setLoadingText('Requesting withdrawal');

        dispatch(withdrawalActions.onCreateWithdrawal({googleAuth, withdrawalPin, amount: amount, currency: currencySelected.type}, `withdrawal/new/0`, response => {
            notify(response.msg, response.code)
            if(response.code == 1){
                setAmount('');
                setWithdrawalPin('');
                setErrors({});
            }
            setloading(false);
        }))
    }

    const newWithdrawal = () => {
        const netAmount = amount;
        // const netAmount = amount ? (parseFloat(amount) - (currencySelected?.fee || 0)).toFixed(8) : '0';

        return (
            <div className="min-h-screen p-4">
                <div className="max-w-7xl mx-auto pt-8">
                    {/* Header */}
                    <div className="text-center mb-12">
                        <h1 className="text-5xl font-bold text-white mb-4 bg-gradient-to-r from-white to-blue-200 bg-clip-text text-transparent">
                            Withdraw Funds
                        </h1>
                        <p className="text-xl text-blue-200">
                            Secure and fast cryptocurrency withdrawals
                        </p>
                        
                        {/* Withdrawal Records Link */}
                        <div className="mt-6">
                            <WebLink 
                                to="/withdrawal-records" 
                                className="inline-flex items-center px-6 py-3 bg-white/10 border border-white/20 rounded-2xl text-white hover:bg-white/20 transition-all duration-300 transform hover:scale-105 backdrop-blur-xl"
                            >
                                <History className="mr-2" size={20} />
                                View Withdrawal Records
                            </WebLink>
                        </div>
                    </div>

                    <div className="flex flex-col lg:grid lg:grid-cols-3 gap-8">
                        {/* Currency Selection & Balance - Mobile First */}
                        <div className="lg:col-span-1 order-1 lg:order-1">
                            <div className="backdrop-blur-xl bg-white/10 rounded-3xl border border-white/20 p-6 shadow-2xl">
                                <h2 className="text-2xl font-bold text-white mb-6 flex items-center">
                                    <Wallet className="mr-3 text-blue-300" />
                                    Select Currency
                                </h2>
                                
                                {/* Currency Grid */}
                                <div className="grid grid-cols-2 gap-3 mb-6">
                                    {finance?.map((currency) => (
                                        <button
                                            key={currency.type}
                                            onClick={() => handleCurrencyChange(currency)}
                                            className={`p-4 rounded-2xl border-2 transition-all duration-300 transform hover:scale-105 ${
                                                currencySelected?.type === currency.type
                                                    ? 'border-blue-400 bg-blue-500/20'
                                                    : 'border-white/20 bg-white/5 hover:bg-white/10'
                                            }`}
                                        >
                                            <div className="flex flex-col items-center text-center">
                                                <div 
                                                    className="w-12 h-12 rounded-full flex items-center justify-center text-white font-bold text-xl mb-2"
                                                    style={{ backgroundColor: currency.color || '#6366f1' }}
                                                >
                                                    {currency.symbol || currency.type?.charAt(0)?.toUpperCase()}
                                                </div>
                                                <div className="text-white font-semibold text-sm">
                                                    {currency.symbol || currency.type}
                                                </div>
                                                <div className="text-gray-300 text-xs">
                                                    {currency.name || currency.type}
                                                </div>
                                            </div>
                                        </button>
                                    ))}
                                </div>

                                {/* Balance Display */}
                                <div 
                                    className="p-6 rounded-2xl border border-white/20 mb-6"
                                    style={{ 
                                        background: `linear-gradient(135deg, ${currencySelected?.color || '#6366f1'}20, ${currencySelected?.color || '#6366f1'}10)`
                                    }}
                                >
                                    <div className="flex items-center justify-between">
                                        <div>
                                            <p className="text-gray-300 text-sm mb-1">Available Balance</p>
                                            <p className="text-white text-2xl font-bold">
                                                {money(currencySelected?.balance, currencySelected?.type)}
                                            </p>
                                        </div>
                                       
                                    </div>
                                </div>

                                {/* Withdrawal Info */}
                                <div className="bg-blue-500/10 border border-blue-400/30 rounded-2xl p-4">
                                    <div className="flex items-start">
                                        <AlertCircle className="text-blue-300 mt-1 mr-3 flex-shrink-0" size={20} />
                                        <div>
                                            <p className="text-white text-sm">
                                                <strong>Min Withdrawal:</strong> {currencySelected?.symbol || currencySelected?.type} {currencySelected?.minimumWithdrawal || '0.001'}<br/>
                                                {/* <strong>Fee:</strong> {currencySelected?.withdrawalCharge || '0.0005'} {currencySelected?.symbol || currencySelected?.type} */}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Withdrawal Form */}
                        <div className="lg:col-span-2 order-2 lg:order-2">
                            <div className="backdrop-blur-xl bg-white/10 rounded-3xl border border-white/20 p-8 shadow-2xl">
                                <form onSubmit={processWithdrawal} className="space-y-8">
                                    {/* Amount Input */}
                                    <div>
                                        <h3 className="text-2xl font-bold text-white mb-4 flex items-center">
                                            <TrendingDown className="mr-3 text-green-300" />
                                            Withdrawal Amount
                                        </h3>
                                        
                                        <div className="relative">
                                            <input
                                                type="number"
                                                value={amount}
                                                onChange={(e) => setAmount(e.target.value)}
                                                className={`w-full bg-white/10 border-2 ${errors.amount ? 'border-red-400' : 'border-white/20'} 
                                                    rounded-2xl px-6 py-4 text-white text-lg placeholder-gray-300 focus:outline-none 
                                                    focus:border-blue-400 transition-all duration-300`}
                                                placeholder="Enter amount"
                                            />
                                            <div className="absolute right-4 top-1/2 transform -translate-y-1/2 text-white font-semibold">
                                                {currencySelected?.symbol || currencySelected?.type}
                                            </div>
                                        </div>
                                        
                                        {errors.amount && (
                                            <p className="text-red-400 text-sm mt-2">{errors.amount}</p>
                                        )}

                                        {/* Amount Suggestions */}
                                        <div className="flex flex-wrap gap-3 mt-4">
                                            {amountSuggestion.map((suggestion) => (
                                                <button
                                                    key={suggestion}
                                                    type="button"
                                                    onClick={() => handleAmountSuggestion(suggestion)}
                                                    className="px-4 py-2 bg-white/10 border border-white/20 rounded-xl text-white text-sm 
                                                        hover:bg-white/20 transition-all duration-300 transform hover:scale-105"
                                                >
                                                    {suggestion} {currencySelected?.symbol || currencySelected?.type}
                                                </button>
                                            ))}
                                        </div>
                                    </div>

                                   

                                    {/* Withdrawal PIN */}
                                    <div>
                                        <h3 className="text-xl font-bold text-white mb-4 flex items-center">
                                            <Shield className="mr-3 text-yellow-300" />
                                            Withdrawal PIN
                                        </h3>
                                        <div className="relative">
                                            <input
                                                type={showPin ? 'text' : 'password'}
                                                value={withdrawalPin}
                                                onChange={(e) => setWithdrawalPin(e.target.value)}
                                                className={`w-full bg-white/10 border-2 ${errors.withdrawalPin ? 'border-red-400' : 'border-white/20'} 
                                                    rounded-2xl px-6 py-4 pr-16 text-white text-lg placeholder-gray-300 focus:outline-none 
                                                    focus:border-blue-400 transition-all duration-300`}
                                                placeholder="Enter your withdrawal PIN"
                                            />
                                            <button
                                                type="button"
                                                onClick={() => setShowPin(!showPin)}
                                                className="absolute right-4 top-1/2 transform -translate-y-1/2 text-gray-300 hover:text-white transition-colors"
                                            >
                                                {showPin ? <EyeOff size={20} /> : <Eye size={20} />}
                                            </button>
                                        </div>
                                        
                                        {errors.withdrawalPin && (
                                            <p className="text-red-400 text-sm mt-2">{errors.withdrawalPin}</p>
                                        )}
                                    </div>

                                    {/* Transaction Summary */}
                                    {amount && parseFloat(amount) > 0 && 1>2 && (
                                        <div className="bg-green-500/10 border border-green-400/30 rounded-2xl p-6">
                                            <h3 className="text-xl font-bold text-white mb-4 flex items-center">
                                                <CheckCircle className="mr-3 text-green-300" />
                                                Transaction Summary
                                            </h3>
                                            <div className="space-y-3">
                                                <div className="flex justify-between items-center text-white">
                                                    <span>Withdrawal Amount:</span>
                                                    <span className="font-semibold text-lg">{amount} {currencySelected?.symbol || currencySelected?.type}</span>
                                                </div>
                                                <div className="flex justify-between items-center text-white">
                                                    <span>Network Fee:</span>
                                                    <span className="font-semibold text-lg text-red-300">-{currencySelected?.fee || '0.0005'} {currencySelected?.symbol || currencySelected?.type}</span>
                                                </div>
                                                <div className="border-t border-white/20 pt-3">
                                                    <div className="flex justify-between items-center">
                                                        <span className="text-green-300 font-semibold text-lg">You'll receive:</span>
                                                        <span className="text-green-300 font-bold text-2xl">{netAmount} {currencySelected?.symbol || currencySelected?.type}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    )}

                                    {/* Submit Button */}
                                    <button
                                        type="submit"
                                        disabled={loading}
                                        className={`w-full py-6 rounded-2xl font-bold text-xl text-white transition-all duration-300 transform
                                            ${loading 
                                                ? 'bg-gray-500 cursor-not-allowed' 
                                                : 'bg-gradient-to-r from-pink-500 to-purple-600 hover:from-pink-600 hover:to-purple-700 hover:scale-105 shadow-2xl hover:shadow-pink-500/25'
                                            }`}
                                    >
                                        {loading ? (
                                            <div className="flex items-center justify-center">
                                                <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-white mr-3"></div>
                                                Processing Withdrawal...
                                            </div>
                                        ) : (
                                            <div className="flex items-center justify-center">
                                                <TrendingDown className="mr-3" size={24} />
                                                Submit Withdrawal Request
                                            </div>
                                        )}
                                    </button>

                                    {/* Security Notice */}
                                    <div className="text-center">
                                        <p className="text-gray-300 text-sm">
                                            🔒 All withdrawals are secured with industry-standard encryption
                                        </p>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>

                    {/* Floating Action Button for Withdrawal Records */}
                    <div className="fixed bottom-6 right-6 z-50">
                        <WebLink 
                            to="/withdrawal-records" 
                            className="flex items-center justify-center w-16 h-16 bg-gradient-to-r from-blue-500 to-purple-600 rounded-full shadow-2xl hover:shadow-blue-500/25 transition-all duration-300 transform hover:scale-110 backdrop-blur-xl"
                            title="View Withdrawal Records"
                        >
                            <History className="text-white" size={24} />
                        </WebLink>
                    </div>

                </div>
            </div>
        );
    }

    return (

        <SiteWide id="main" title={"Account Fund"}>
            <Section overlayText={loadingText} loading={loading} title={'Account Withdrawal'} style={{}}>

            
            {newWithdrawal()}

            </Section>

        </SiteWide>
    );
}

export default Withdrawal;
